import { create } from "zustand";
import { getReviewQueueSummaryApi, type ReviewQueueSummary } from "@/portals/admin/api/adminReviewQueueApi";

interface AdminReviewQueueState {
  summary: ReviewQueueSummary | null;
  refreshSummary: () => Promise<void>;
}

/** The shared queue's summary for the admin portal — one fetch feeds the dashboard card and the nav badge. */
export const useAdminReviewQueueStore = create<AdminReviewQueueState>((set) => ({
  summary: null,
  refreshSummary: async () => {
    const { data } = await getReviewQueueSummaryApi();
    // A failed read keeps the last known value rather than flashing the badge away.
    if (data) set({ summary: data });
  },
}));
